import i18n from '@/i18n';

export { cn } from '@xtreed/academy-shared/ui';

/** Inline SVG placeholder for courses (dark bg + Xtreed green text). */
export function formatUsd(value: number, locale: string) {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 4,
  }).format(value);
}

function buildCoursePlaceholder(label: string) {
  return `data:image/svg+xml,${encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="400" height="225" viewBox="0 0 400 225"><rect width="400" height="225" fill="#0d0a17"/><text x="50%" y="50%" text-anchor="middle" dy=".3em" fill="#90ee80" font-family="system-ui,sans-serif" font-size="28" font-weight="600" opacity="0.7">${label}</text></svg>`,
  )}`;
}

export const COURSE_BANNER_PLACEHOLDER = buildCoursePlaceholder('');

export let COURSE_PLACEHOLDER = buildCoursePlaceholder(
  i18n.t('common:coursePlaceholder'),
);

i18n.on('languageChanged', () => {
  COURSE_PLACEHOLDER = buildCoursePlaceholder(
    i18n.t('common:coursePlaceholder'),
  );
});
